var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoneicon = function SvgNoneicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 .25a7.75 7.75 0 1 0 0 15.5A7.75 7.75 0 0 0 8 .25ZM14.2 8a6.138 6.138 0 0 1-1.31 3.797L4.203 3.11A6.138 6.138 0 0 1 8 1.8 6.2 6.2 0 0 1 14.2 8ZM3.11 4.202A6.138 6.138 0 0 0 1.8 8 6.2 6.2 0 0 0 8 14.2a6.139 6.139 0 0 0 3.798-1.31L3.11 4.202Z",
    clipRule: "evenodd"
  })));
};
export default SvgNoneicon;